import { render, staticRenderFns } from "./CategoryResultSection.vue?vue&type=template&id=c896a538&scoped=true&"
import script from "./CategoryResultSection.vue?vue&type=script&lang=js&"
export * from "./CategoryResultSection.vue?vue&type=script&lang=js&"
import style0 from "./CategoryResultSection.vue?vue&type=style&index=0&id=c896a538&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c896a538",
  null
  
)

export default component.exports